export default __webpack_public_path__ + "static/media/footer-w@2x.d6580d8a.png";